'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _recompose = require('recompose');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withGroupSwitchState = (0, _recompose.withState)('switched', 'asGroupSwitch__setSwitched', function (_ref) {
  var defaultSelected = _ref.defaultSelected;
  return defaultSelected || '';
});

var withGroupSwitchHandlers = (0, _recompose.withHandlers)({
  onSwitch: function onSwitch(_ref2) {
    var asGroupSwitch__setSwitched = _ref2.asGroupSwitch__setSwitched,
        disabled = _ref2.disabled,
        onChange = _ref2.onChange,
        onClick = _ref2.onClick;
    return function (value) {
      // Only if not disabled
      if (disabled !== value) {
        // If onChange, call onChange with opposite value of switched

        if (onChange) {
          onChange(value);
        }
        // Update HOC state
        asGroupSwitch__setSwitched(value);

        // Call onClick if set
        if (onClick) {
          onClick(value);
        }
      }
    };
  }
});

var mapGroupSwitchProps = (0, _recompose.mapProps)(function (_ref3) {
  var asGroupSwitch__setSwitched = _ref3.asGroupSwitch__setSwitched,
      rest = (0, _objectWithoutProperties3.default)(_ref3, ['asGroupSwitch__setSwitched']);
  return (0, _extends3.default)({}, rest);
});

var asGroupSwitch = (0, _recompose.compose)(withGroupSwitchState, withGroupSwitchHandlers, mapGroupSwitchProps);

exports.default = asGroupSwitch;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/form/helpers/asGroupSwitch.js
// module id = 510
// module chunks = 0